import React from 'react';
import styled from 'styled-components';
import { BasicInput } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';

import { DefaultOptionsModalBodyProps } from './DefaultOptionsModalBodyInterface';

const ContentWrapper = styled.div`
    > div {
        margin-bottom: 16px;
        &:last-child {
            margin-bottom: 8px;
        }
    }
`;

export const DefaultOptionsModalBody = ({
    templateObject,
    onSubjectChange,
    onFromEmailChange,
    onFromNameChange,
}: DefaultOptionsModalBodyProps): JSX.Element => {
    const { t } = useTranslation();
    return (
        <ContentWrapper>
            <BasicInput
                label={t('frommail')}
                fullWidth
                defaultValue={templateObject?.FromEmail}
                onChange={(e) => {
                    onFromEmailChange(e.target.value);
                }}
            />
            <BasicInput
                label={t('fromname')}
                fullWidth
                defaultValue={templateObject?.FromName}
                onChange={(e) => {
                    onFromNameChange(e.target.value);
                }}
            />
            <BasicInput
                label={t('subject')}
                fullWidth
                defaultValue={templateObject?.Body?.Subject ?? ''}
                onChange={(e) => {
                    onSubjectChange(e.target.value);
                }}
            />
        </ContentWrapper>
    );
};
